
<!--
 * @Description: 常规工作/日常事务 学生惩处 列表
 * @Author: PF
 * @Date: 2023-01-05 15:11:27
 * @LastEditors: PF
 * @LastEditTime: 2023-12-06 14:16:19
-->
<template>
  <div>
    <el-dialog class="wp70 hp80" :model-value="openList" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Suitcase />
          </el-icon>
          <span class="header-title">学生惩处</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="openList=false;homeCloseWindow('openReturn', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <div class="list-page pl0 pr0 pt0 pb0">
      <el-container>
        <el-header>
            <!-- 搜索区域 BEGIN -->
            <el-form class="search-box" :model="dataGrid.parms" @submit.enter.prevent>

              <el-form-item>
                <el-input placeholder="学生姓名" v-model="dataGrid.parms.xsxm" clearable @clear="bindTable()" @keyup.enter="bindTable()">
                  <template #suffix>
                    <el-icon class="el-input__icon pointer" @click="bindTable()">
                      <search />
                    </el-icon>
                  </template>
                </el-input>
              </el-form-item>
              <el-form-item>
                <el-select placeholder="学期" v-model="dataGrid.parms.xqid" clearable filterable @change="bindTable()">
                  <el-option v-for="item in xqData" :key="item.id" :label="item.xqmc" :value="item.id" />
                </el-select>
              </el-form-item>
              <el-button type="success" @click="bindTable()"><span class="el-icon--left iconfont icon-sousuo"></span>查询</el-button>
            </el-form>
            <!-- 搜索区域 END -->
          <!-- 按钮区域 BEGIN -->
          <div class="button-box">
            <el-button class="w200" type="primary" @click="openAdd=true;row={jzgmc:userInfo.xm,jzgid:userInfo.id}"><span class="iconfont icon-chuangjian"></span>添加</el-button>
            <el-button class="ml10 w200" type="warning" @click="remove()"><span class="iconfont icon-shanchu"></span>批量删除</el-button>
          </div>
          <!-- 按钮区域 END -->
        </el-header>
          <el-main>
          <el-table :data="dataGrid.data" :default-sort="dataGrid.orderBy" v-loading="dataGrid.loading" @sort-change="dataGrid.sortChange" @selection-change="dataGrid.selectionChange" height="100%" border stripe>
            <!-- 冻结列-Left BEGIN -->
            <el-table-column type="selection" width="55" align="center" />
            <el-table-column label="序号" type="index" width="80" fixed align="center" />
            <!-- 冻结列-Left END -->
            <el-table-column label="学生" prop="xsxm" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']">
              <template #default="scope">
                <span style="color: #409EFF;cursor: pointer;" @click="openDetailXueSheng=true;row={xsid:scope.row.id, xm:scope.row.xsxm}">{{scope.row.xsxm}}</span>
              </template>
            </el-table-column>
            <el-table-column label="班级" prop="bjmc" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']"/>
            <el-table-column label="班主任" prop="bzrxm" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']"/>
            <!-- <el-table-column label="学期" prop="xqmc" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']"/> -->
            <el-table-column label="违纪日期" prop="wjrq" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']"/>
            <!-- <el-table-column label="违纪简况" prop="wjjk" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']"/> -->
            <el-table-column label="违纪类别" prop="wjlbbt" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']"/>
            <el-table-column label="处分名称" prop="cfmcbt" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']"/>
            <!-- 冻结列-Right BEGIN -->
            <el-table-column label="操作" width="180" fixed="right" align="center">
              <template #default="scope">
                <el-button link type="success" @click="openDetail=true; row=scope.row">详情</el-button>
                <el-button link type="primary" @click="openEdit=true; row={jzgmc:userInfo.xm,jzgid:userInfo.id,id:scope.row.id}">修改</el-button>
                <el-button link type="warning" @click="dataGrid.multipleSelection=[scope.row.id]; remove()">删除</el-button>
              </template>
            </el-table-column>
            <!-- 冻结列-Right END -->
          </el-table>
        </el-main>
        <el-footer>
          <pagination :pagination="dataGrid.pagination" @ReturnData="bindTable" />
        </el-footer>
      </el-container>
      </div>
    </el-dialog>
  </div>
  <add v-if="openAdd" v-model:openAdd="openAdd" :row="row" @ReturnData="bindTable" />
  <edit v-if="openEdit" v-model:openEdit="openEdit" :row="row" @ReturnData="bindTable" />
  <detail v-if="openDetail" v-model:openDetail="openDetail" :row="row" />
  <detailxuesheng v-if="openDetailXueSheng" v-model:openDetail="openDetailXueSheng" :row="row" />
</template>

<script setup>
import { ref, watch, defineProps, defineEmits } from 'vue'
import { loadList, submitDataGridAction, loadSelect, homeCloseWindow } from '@/api/common.js'
import pagination from '@/components/pagination.vue'
import add from './add.vue'
import edit from './edit.vue'
import detail from './detail.vue'
import detailxuesheng from '@/components/xuesheng/detail'

const props = defineProps({ open: { type: String, required: true }, row: { type: Object, required: false } })
const emits = defineEmits(['openReturn', 'ReturnData'])

const dataGrid = ref({
  parms: {},
  data: [],
  pagination: {},
  loading: false,
  orderBy: { prop: 'bjid', order: 'ascending' },
  multipleSelection: [],
  sortChange: function (column) {
    dataGrid.value.orderBy.prop = column.prop
    dataGrid.value.orderBy.order = column.order
    bindTable()
  },
  selectionChange: function (selection) {
    dataGrid.value.multipleSelection = selection.map(item => (item.id))
  }
})
const bindTable = async (pageNo, pageSize) => {
  dataGrid.value.parms.bzrid = userInfo.value.id
  loadList({
    url: '/api/v2/xuesheng/xueshengchengchu/pagelist',
    pageNo: pageNo || 1,
    pageSize: pageSize || 100,
    dataGrid: dataGrid.value,
    loadSuccess: function () {
      dataGrid.value.multipleSelection = []
    }
  })
}
// 弹窗
const row = ref()
const openAdd = ref(false)
const openEdit = ref(false)
const openDetail = ref(false)
const openList = ref(false)
const openDetailXueSheng = ref(false)

// 删除
const remove = async () => {
  submitDataGridAction({
    url: '/api/v2/xuesheng/xueshengchengchu',
    dataGrid: dataGrid.value,
    confirmTitle: '确定要删除吗?',
    method: 'delete',
    callback: function () {
      bindTable()
    }
  })
}
const xqData = ref()
const userInfo = ref({})
watch(
  () => props.open,
  () => {
    if (props.open === 'xueshengchengchu') {
      openList.value = true
      userInfo.value = JSON.parse(sessionStorage.getItem('USER_INFO'))
      loadSelect({
        url: '/api/v2/pdp/xueqi/list',
        data: xqData,
        order: 'sx',
        sort: 'asc',
        loadSuccess: function (res) {
          res.data.forEach((element) => {
            if (element.sfdqxq === true) {
              dataGrid.value.parms.xqid = element.id
              bindTable()
            }
          })
        }
      })
    } else {
      openList.value = false
    }
  },
  { deep: true, immediate: true }
)
</script>
